function isNumber(value) {
  return typeof value === 'number' && Number.isFinite(value);
}

function getVertices(graph) {
  if (!graph || typeof graph.getVertices !== 'function') {
    return [];
  }
  const vertices = graph.getVertices();
  return Array.isArray(vertices) ? vertices : [];
}

function getNodeLayoutId(cell) {
  if (!cell) {
    return null;
  }
  if (typeof cell.getKey === 'function') {
    const key = cell.getKey();
    if (key !== null && key !== undefined && key !== '') {
      return String(key);
    }
  }
  if (cell.key !== null && cell.key !== undefined && cell.key !== '') {
    return String(cell.key);
  }
  if (cell.id !== null && cell.id !== undefined && cell.id !== '') {
    return String(cell.id);
  }
  const value = cell.value;
  if (value && typeof value.getId === 'function') {
    const id = value.getId();
    if (id !== null && id !== undefined && id !== '') {
      return String(id);
    }
  }
  if (value && value.id !== null && value.id !== undefined && value.id !== '') {
    return String(value.id);
  }
  return null;
}

function getLayoutId(layout) {
  if (!layout) {
    return null;
  }
  const candidates = [layout.node_id, layout.nodeId, layout.id, layout.key];
  for (let i = 0; i < candidates.length; i += 1) {
    const id = candidates[i];
    if (id !== null && id !== undefined && id !== '') {
      return String(id);
    }
  }
  return null;
}

function applyLayoutToCell(graph, cell, layout) {
  if (!cell || !layout || !isNumber(layout.x) || !isNumber(layout.y)) {
    return false;
  }
  const geometry = typeof cell.getGeometry === 'function' ? cell.getGeometry() : cell.geometry;
  if (!geometry) {
    return false;
  }

  geometry.x = layout.x;
  geometry.y = layout.y;
  geometry.relative = Boolean(layout.relative);

  const model = graph && typeof graph.getModel === 'function' ? graph.getModel() : null;
  if (model && typeof model.setGeometry === 'function') {
    model.setGeometry(cell, geometry);
  } else if (typeof cell.setGeometry === 'function') {
    cell.setGeometry(geometry);
  } else {
    cell.geometry = geometry;
  }
  return true;
}

function applyNodeLayouts(graph, layouts) {
  if (!Array.isArray(layouts) || layouts.length === 0) {
    return false;
  }

  const vertices = getVertices(graph);
  if (vertices.length === 0) {
    return false;
  }

  const verticesById = new Map();
  vertices.forEach((vertex) => {
    const id = getNodeLayoutId(vertex);
    if (id !== null && !verticesById.has(id)) {
      verticesById.set(id, vertex);
    }
  });

  const hasLayoutIds = layouts.some((layout) => getLayoutId(layout) !== null);
  let changed = false;

  if (hasLayoutIds) {
    layouts.forEach((layout) => {
      const id = getLayoutId(layout);
      const vertex = id !== null ? verticesById.get(id) : null;
      changed = applyLayoutToCell(graph, vertex, layout) || changed;
    });
  } else {
    layouts.forEach((layout, index) => {
      changed = applyLayoutToCell(graph, vertices[index], layout) || changed;
    });
  }

  if (changed && graph && typeof graph.refresh === 'function') {
    graph.refresh();
  }
  return changed;
}

function isAutoLayoutEnabled(storageKey, storage) {
  if (!storageKey || !storage || typeof storage.getItem !== 'function') {
    return true;
  }
  try {
    return storage.getItem(storageKey) !== 'false';
  } catch (e) {
    return true;
  }
}

function applyStoredOrDefaultLayout(graph, layouts, storageKey, storage) {
  if (!isAutoLayoutEnabled(storageKey, storage) && applyNodeLayouts(graph, layouts)) {
    return 'stored';
  }
  if (graph && typeof graph.applyDefaultLayout === 'function') {
    graph.applyDefaultLayout();
  }
  return 'default';
}

function coordinateFromCell(cell) {
  const geometry = typeof cell.getGeometry === 'function' ? cell.getGeometry() : cell.geometry;
  if (!geometry) {
    return null;
  }

  const coordinate = {
    x: isNumber(geometry.x) ? geometry.x : 0,
    y: isNumber(geometry.y) ? geometry.y : 0,
    relative: Boolean(geometry.relative),
  };
  return coordinate;
}

function getNodeLayouts(graph) {
  return getVertices(graph)
    .map(coordinateFromCell)
    .filter(Boolean);
}

function attachNodeLayouts(json, graph) {
  return Object.assign({}, json || {}, {
    nodelayouts: getNodeLayouts(graph),
  });
}

module.exports = {
  applyNodeLayouts,
  applyStoredOrDefaultLayout,
  attachNodeLayouts,
  getNodeLayoutId,
  getNodeLayouts,
  isAutoLayoutEnabled,
};
